import React from "react";
import { Container } from "reactstrap";
import SideBar from "../../components/sidebar/Sidebar";
//import axios from "axios";
import { Notification } from "../../components/alerting-visitors/notification";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import "../../css/myestare.css";

function TrusteeCredentials() {

  return (
    <TrusteeBase>
      <div className="mt-5"></div>
      <SideBar>
        <div style={{ marginTop: "30px" }}>
          <Notification />
        </div>
        <div>
          <div style={{ display: "flex", justifyContent: "left" }}>
            <Container>
              <table id="table" className="property-table" cellSpacing={1000}>
                <tr style={{ height: "50px" }}>
                  <th style={{ paddingRight: "20px", paddingLeft: "20px" }}>
                    nonFinancialAccount
                  </th>
                  <th style={{ paddingRight: "20px", paddingLeft: "20px" }}>
                    document
                  </th>
                  <th style={{ paddingRight: "20px", paddingLeft: "20px" }}>
                    Notes
                  </th>
                </tr>
                
              </table>
            </Container>
          </div>
        </div>
      </SideBar>
    </TrusteeBase>
  );
}

export default TrusteeCredentials;
